import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { InitiativeCard } from './InitiativeCard';
import { initiatives } from '../../data/initiatives';
import { fadeUp } from '../../utils/motion';
type IdeasSectionProps = {
  id: string;
  title: string;
  body: string;
  link?: {
    label: string;
    href: string;
  };
  tone?: 'white' | 'muted';
};
export function IdeasSection({
  id,
  title,
  body,
  link,
  tone = 'white'
}: IdeasSectionProps) {
  const headingId = `${id}-title`;
  return <section id={id} aria-labelledby={headingId} className={`scroll-mt-20 border-t border-line py-20 lg:py-28 ${tone === 'muted' ? 'bg-surface-bg' : 'bg-white'}`} data-id="element-680" data-mp="1hdmmeqb51emd">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-681" data-mp="17engvglo5z3l">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-682" data-mp="17h052bi0t5p3">
          <h2 id={headingId} className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-683" data-mp="2xps10lusva50">
            {title}
          </h2>
          <div className="lg:col-span-7 lg:pt-2" data-id="element-684" data-mp="1uhl5gq6q9ih3">
            <p className="text-xl text-ink-dark leading-relaxed" data-id="element-685" data-mp="1uh1vpwr8e0e5">{body}</p>
            {link && <a href={link.href} className="mt-5 inline-flex items-center gap-2 font-semibold text-navy hover:text-navy-light transition-colors duration-150 whitespace-nowrap rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-686" data-mp="295y1fn5tf1bl">
                {link.label}
                <ArrowRight size={16} aria-hidden="true" data-id="element-687" data-mp="1qg9kwz2pnnfr" />
              </a>}
          </div>
        </motion.div>

        <motion.ul {...fadeUp} className="space-y-6" data-id="element-688" data-mp="1lg3lgwq78wn4">
          {initiatives.map(initiative => <li key={initiative.slug} data-id="element-689" data-mp="31tlg6lkemxqb">
              <InitiativeCard initiative={initiative} data-id="element-690" data-mp="2ww251uj0712l" />
            </li>)}
        </motion.ul>
      </div>
    </section>;
}